/* @flow */
import React from 'react';

export class ComponentWithInjectedProps<
  Props = {},
  State = {},
  InjectedProps = {}
> extends React.Component<Props, State> {
  // flow-disable-next-line This is a hack to override the internal type of `props`, but maintain a reasonable external component interface type
  props: Props & InjectedProps;
}

export class PureComponentWithInjectedProps<
  Props = {},
  InjectedProps = {}
> extends React.PureComponent<Props> {
  // flow-disable-next-line This is a hack to override the internal type of `props`, but maintain a reasonable external component interface type
  props: Props & InjectedProps;
}
